export default __webpack_public_path__ + "static/media/orderSuccess2.b5c0f0b9.gif";